import React, { useContext, useState } from 'react';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { scroller } from 'react-scroll';
import { useGetEventsQuery } from '../../../redux/slices/eventSlice';
import PublicEventsContext from './PublicEventsContext';

// Components
import TruckEvent from './TruckEvent';
import LocationEvent from './LocationEvent';

import styles from './PublicEvents.module.postcss';

dayjs.extend(isoWeek);

const OFFSET = -100;

function PublicEventsList() {
  const { truckId, locationId, scrollTo } = useContext(PublicEventsContext);
  const [page, setPage] = useState(1);

  const pageDate = dayjs().add(page - 1, 'weeks');
  const startDate = pageDate.startOf('week').format('M-D-YY');
  const endDate = pageDate.endOf('week').format('M-D-YY');
  const weekOfDate = pageDate.isoWeekday(1).format('MMMM Do');

  const { data = {}, isFetching } = useGetEventsQuery({
    with_active_trucks: true,
    page: 1,
    page_size: 300,
    start_date: startDate,
    end_date: endDate,
    ...(truckId ? { for_trucks: truckId, include_locations: true, include_static_map: true } : {}),
    ...(locationId ? { for_locations: locationId, include_bookings: true } : {}),
  });
  const events = data.events || [];

  const onPageChange = (difference) => {
    setPage((prevPage) => prevPage + difference);
    if (scrollTo) {
      scroller.scrollTo(scrollTo, { offset: OFFSET });
    }
  };

  const displayedEvents = events.reduce((acc, event) => {
    if (truckId) {
      acc.push(
        <TruckEvent
          key={event.id}
          event={event}
        />
      );
    } else if (locationId) {
      acc.push(
        <LocationEvent
          key={event.id}
          event={event}
        />
      );
    }
    return acc;
  }, []);

  return (
    <div>
      <div className={styles.EventsListInner}>
        { displayedEvents.length > 0 &&
          <div className={styles.PublicEvent_container}>
            {displayedEvents}
          </div>
        }

        { displayedEvents.length === 0 && !isFetching &&
          <p className={styles.NoEvents + ' Box u-mt1 u-mb2'}>No events scheduled for the week of {weekOfDate}</p>
        }
      </div>

      <div className={styles.EventNav + ' u-mt2'}>
        <div className={styles.EventNav_back + ' Button Button--wide'} onClick={() => onPageChange(-1)}>Previous week</div>
        <div>Viewing week of {weekOfDate}</div>
        <div className='Button Button--wide' onClick={() => onPageChange(1)}>Next week</div>
      </div>
    </div>
  );
}

export default PublicEventsList;
